import type { MarketVariants } from '@/lib/i18n'

export type Slide09Copy = {
  title: string
  intro: string
  card1Title: string
  card1Body: string
  card2Title: string
  card2Body: string
  card3Title: string
  card3Body: string
  target: string
}

export const copy: MarketVariants<Slide09Copy> = {
  US: {
    title: 'Different stories, same goals',
    intro: "Scams change shape but they're always after the same things:",
    card1Title: 'Your Personal Information',
    card1Body: 'To sell on, or to use for identity theft in your name.',
    card2Title: 'Your Account Access',
    card2Body: 'Passwords and logins to steal more or target others.',
    card3Title: 'Your Money',
    card3Body: 'Direct theft through wire transfers, gift cards, cryptocurrency.',
    target: 'Profit',
  },
  GB: {
    // "Wire transfers" reads as American to GB ears; "bank transfers" is the
    // everyday term that covers Faster Payments / BACS without jargon.
    card3Body: 'Direct theft through bank transfers, gift cards, cryptocurrency.',
  },
  CA: {
    // Interac e-Transfers are the dominant peer-to-peer payment rail in Canada
    // and a huge channel for scam losses, so they belong in the example.
    card3Body: 'Direct theft through bank transfers, e-Transfers, gift cards, cryptocurrency.',
  },
  AU: {
    card3Body: 'Direct theft through bank transfers, gift cards, cryptocurrency.',
  },
  QA: {
    // Qatar follows the UK usage: "bank transfers", not "wire transfers".
    card3Body: 'Direct theft through bank transfers, gift cards, cryptocurrency.',
  },
  ar: {
    title: 'قصص مختلفة، أهداف واحدة',
    intro: 'يتغيّر شكل الاحتيال، لكنه يسعى دائماً وراء الأشياء نفسها:',
    card1Title: 'معلوماتك الشخصية',
    card1Body: 'لبيعها، أو لاستخدامها في سرقة هويتك.',
    card2Title: 'الوصول إلى حساباتك',
    card2Body: 'كلمات المرور وبيانات الدخول لسرقة المزيد أو استهداف آخرين.',
    card3Title: 'أموالك',
    card3Body: 'سرقة مباشرة عبر التحويلات المصرفية وبطاقات الهدايا والعملات الرقمية.',
    target: 'الربح',
  },
}
